export function redirectBlank(url: string): void {
  var a = document.createElement("a");
  a.target = "_blank";
  a.href = url;
  a.click();
}
